import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M9.57677 38.7299H11.6037L33.7152 16.6376L31.6691 14.5915L9.57677 36.703V38.7299ZM38.5267 15.0069L33.2998 9.78008L37.019 6.08008L42.2266 11.2877L38.5267 15.0069ZM7.30762 40.9991V35.7915L31.7191 11.38L36.9267 16.5876L12.5152 40.9991H7.30762ZM32.6922 15.5953L31.6691 14.5915L33.7152 16.6376L32.6922 15.5953Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map